import React, { useEffect, useState } from "react";
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import useResizeWindow from "../../../utils/hook/useResizeWindows";

import "./Layout.scss";

const Layout = ({ children }) => {
  const width = useResizeWindow();
  const [collapsed, setCollapsed] = useState(false);
  const [fullyCollapsed, setFullyCollapsed] = useState(false);
  const collapsedWidth = "calc(100% - 80px)";
  const sidebarWidth = width <= 1350 ? "calc(100% - 200px)" : "calc(100% - 220px)";
  const fullyCollapsedWidth = "100%";
  const responsiveWidth = fullyCollapsed
    ? fullyCollapsedWidth
    : collapsed
    ? collapsedWidth
    : sidebarWidth;
  // How much room the sidebar takes, as a number. The footer lives outside
  // this component, so it learns the width through a custom property and can
  // stop short of the sidebar the same way the header does.
  const sidebarSize = fullyCollapsed ? 0 : collapsed ? 80 : width <= 1350 ? 200 : 220;
  useEffect(() => {
    if (width <= 1590) {
      setCollapsed(true);
    } else {
      setFullyCollapsed(false);
      setCollapsed(false);
    }
  }, [width]);

  useEffect(() => {
    document.documentElement.style.setProperty("--app-sidebar-width", `${sidebarSize}px`);

    // Pages without a sidebar, such as sign in, get the full width back.
    return () => document.documentElement.style.setProperty("--app-sidebar-width", "0px");
  }, [sidebarSize]);
  return (
    <div className="layout">
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} fullyCollapsed={fullyCollapsed} />
      <div
        className="main-block"
        style={{
          width: responsiveWidth,
        }}>
        <header className="header" style={{ width: responsiveWidth }}>
          <Header
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            fullyCollapsed={fullyCollapsed}
            setFullyCollapsed={setFullyCollapsed}
          />
        </header>
        <main className="content">
          {children}
          <div id="scroll-target"></div>
        </main>
      </div>
    </div>
  );
};
export default Layout;
